import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { RouterConstants } from '../../../core/routing/constants/app-paths.constant';
import { SelectLanguageConstants } from '../../../common/components/select-lang/constants/select-lang.consts';

@Component({
  selector: 'iposcen-ipos-help-manage-user-account',
  templateUrl: './ipos-help-manage-user-account.component.html',
  styleUrls: ['./ipos-help-manage-user-account.component.scss']
})
export class IposHelpManageUserAccountComponent implements OnInit {
  @Output() readonly sideNav = new EventEmitter();
  loginUserRole = sessionStorage.getItem('userRole');
  constructor(
    private router: Router
  ) { }
  ngOnInit(): void {
  }
  navigate() {
    this.sideNav.emit(['creatingUserAccount', '', '']);
  }

}
